// Full Panoramax viewer (<pnx-viewer>, with map): used by the contribution pages.
import './fontawesomeConfig'
import '@panoramax/web-viewer/build/cjs/index.js'
import './panoramaxSetup'
